<template>
  <v-dialog v-model="_showDialog" max-width="450px" @click:outside="_showDialog = false" @keydown="_showDialog = false">
    <v-card>
      <v-card-title class="headline">
        <template v-if="tipo == 'Tabelas'">Tabelas do Expurgo # {{ items.id }}</template>
        <template v-else>Datas e Versões - Expurgo # {{ items.id }}</template>
      </v-card-title>
      <v-card-text v-if="tipo == 'Datas'">{{ datas[0] }}.</v-card-text>
      <v-card-text v-else>{{ tabelas.join(', ') }}.</v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn color="green darken-1" text @click="_showDialog = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      items: {
        type: Object,
        default: () => {}
      },
      tipo: {
        type: String
      },
      showDialog: {
        type: Boolean,
        default: false
      }
    },

    emits: ['update:showDialog'],

    data() {
      return {
        datas: [],
        tabelas: []
      };
    },

    computed: {
      _showDialog: {
        get() {
          return this.showDialog;
        },
        set(newValue) {
          this.$emit('update:showDialog', newValue);
        }
      }
    },

    methods: {
      MontarConteudo() {
        if (this.tipo == 'Datas') {
          this.datas = [];
          let temporario = this.items.datas_registros_versoes;
          let datasVersoes = JSON.parse(temporario);

          for (let i = 0; i < datasVersoes.length; i++) {
            this.datas.push(
              'Data: ' + datasVersoes[i].data.split('-').reverse().join('/') + ' - versão: ' + datasVersoes[i].versao
            );
          }
        } else {
          this.tabelas = [];
          let temporario = this.items.tabelas;
          let tabelas = JSON.parse(temporario);
          this.tabelas = tabelas;
        }
      }
    },

    watch: {
      showDialog(newValue) {
        if (newValue) {
          this.MontarConteudo();
        }
      }
    }
  };
</script>
<style>
  .bodylista {
    font-size: 0.95rem !important;
    font-weight: normal !important;
  }
</style>
